import {apiAuth} from '../../../services/ApiService';
import {createRequest} from '../../../helpers/RequestHelper';

export function buscarTodosFormulariosComInscricaoPorCpf( onSuccess, onError) {
    const path = `/forms/internos/with-subscription`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function buscarForms(url,  onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: url, onSuccess, onError
    });
}


// WEBPACK FOOTER //
// ./src/view/internal_forms/actions/InternalActions.js